import React from 'react'

import { ShadowRoot } from './ShadowRoot';

import CollapsibleList from '../components/CollapsibleList';

import { getImageUrl, Sizes } from './blocks/editable/Img'

import ShareModal from '../components/modal/ShareModal'
import BadgeBlock from '../components/BadgeBlock';

import General from '../utils/General'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Cart from '../utils/Cart'
import Event from "../utils/Event";
import { getIconType, getStandardIcon, getSVGIcon } from './constants/utils';
import SVG, { Props as SVGProps } from 'react-inlinesvg';
import { productSettingsIds } from './constants/general';


export default class Product extends React.Component {
  constructor(props){
    super(props)

    this.SECTION_RENDERERS = {
      product_image: '_renderProductMedia',
      description: '_renderProductDescription',
      metafields: '_renderMetaFields',
      title: '_renderProductName',
      price: '_renderProductPrice',
      variants: '_renderProductVariants',
      custom_message_options: '_renderCustomMessage',
      subscribe_save: '_renderSubScribeSave',
      quantity_cart: '_renderQuantityAndButtons',
      share_product: '_renderShareSection'
    };

    for (let i = 1; i <= 9; i++) {
      this.SECTION_RENDERERS[`storefront_detail_${i}`] = `_renderStorefrontDetail${i}`;
      this[`_renderStorefrontDetail${i}`] = () => this._renderDetail(i);
    }

    // key is incremented as the slider js functions
    // overwrite the html so we want to refresh it
    // as React is out of sync when
    // adding/editing/deleting the images
    this.state = {
      key: 0,
      loading: true,
      quantity: 1,
      customMessage: [],
      editable: props.editable,
      website: window.CURRENT_WEBSITE,
      options: [],
      product: props.product,
      variant: props.variant,
      variantOptions: props.variantOptions,
      customMessageOptions: props.customMessageOptions,
      subscribeAndSaveProduct: props.subscribeAndSaveProduct,
      subscribeAndSaveVariantOptions: props.subscribeAndSaveVariantOptions,
      subscribeAndSaveSettings: props.subscribeAndSaveSettings,
      extra: props.extra,
      purchaseOption: props.purchaseOption,
      frequency: null,
      evenColumnWidth: props.evenColumnWidth,
      imageSliderPosition: props.imageSliderPosition,
      layoutOrder: props.layoutOrder,
      variantQuantities: Array(props.product.variants?.length).fill(0),
      imageShape: props.imageShape,
      carouselShape: props.carouselShape,
      imageNavShape: props.imageNavShape,
      imageBorderColor: props.imageBorderColor || "",
      imageSelectedBorderColor: props.imageSelectedBorderColor || "",
      imageNavButtonColor: props.imageNavButtonColor || "",
    }

    this.quantityInput = React.createRef()
  }

  componentDidMount() {
    this._setup()
    this.getVariantIdFromParams()
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _setup(){
    setTimeout(() => {
      General.updateAll()
    }, 500)
  }

  _renderEditButton(id, defaultIndex = null){
    const { editable } = this.state;
    return (
      editable && this.props.productPage && (
        <div
          className="edit edit-button"
          onClick={() => {
            this.props.updateProductSettingModalState(true, id, defaultIndex)
          }}
        >
          <i className="icon icon--xs icon-Pencil" />
        </div>
      )
    )
  }

  getQuickSettingsHighlightClass() {
    let {extra, editable} = this.state
    const displayElementHighlight = (extra?.display_quick_settings_element_highlight !== false) && editable && this.props.productPage;
    return displayElementHighlight ? 'hover-outline' : '';
  }

  _renderLayoutSection(key) {
    const rendererName = this.SECTION_RENDERERS[key];
    if (!rendererName) {
      return null;
    }
    if (typeof this[rendererName] === 'function') {
      const output = this[rendererName]();
      return output === 'HIDE' ? null : output;
    }
    return null;
  }

  _renderColumnSections(position, layoutOrder) {
    return layoutOrder
      .filter(section => section.position === position)
      .map(section => (
        <React.Fragment key={section.key}>
          {this._renderLayoutSection(section.key)}
        </React.Fragment>
      ));
  }

  _handleAddToCart(){
    let {
      variant,
      frequency,
      product,
      purchaseOption,
      subscribeAndSaveProduct,
      quantity,
      customMessage,
      variantOptions,
      customMessageOptions,
      variantQuantities 
    } = this.state
  if (product.isVariantBundle) {
    const threshold = product.bundleProductQty || product.productQty;
    const total = variantQuantities.reduce((t, q) => t + q, 0);
  
    if (total < threshold) {
      Notify.error(`Total variant quantity must be ${threshold} for ${product.productName}`);
      return;
    }
    
    let bundleItemsString = "";
    product.variants.forEach((variant, idx) => {
      const qty = variantQuantities[idx] || 0;
      if (qty > 0) {
        bundleItemsString += product.campaignProductId + "." + variant.variantDetailId + ":" + qty + "|";
      }
    });
    const existingBundleItems = JSON.parse(sessionStorage.getItem("bundleItems") || "{}");
    if (!existingBundleItems[product.campaignProductId]) {
      existingBundleItems[product.campaignProductId] = {};
  }
    existingBundleItems[product.campaignProductId] = bundleItemsString;
    sessionStorage.setItem("bundleItems", JSON.stringify(existingBundleItems));
    const bundleItems = sessionStorage.getItem("bundleItems") !== null ? JSON.parse(sessionStorage.getItem("bundleItems")) : {};
    const bundleStringArray = sessionStorage.getItem("bundleStringArray") !== null ? JSON.parse(sessionStorage.getItem("bundleStringArray")) : {};;
    const breakTag = <br></br>;

    for (const bundleProdId in bundleItems) {
      let bundleString = bundleProdId + "|1|";
      let bundleVariantAndQty = "";
      const bundleProdArray = bundleItems[bundleProdId].split("|");
      if (product?.campaignProductId != bundleProdId) {
        continue;
      }
      for (let i = 0; i < bundleProdArray.length; i++) {
        if (bundleProdArray[i]) {
          const [bundleProdData, qty] = bundleProdArray[i].split(":");
          const variantId = bundleProdData.split(".")[1];
          const variant = product.variants.find(v => v.variantDetailId == variantId);
          if (variant) {
            bundleVariantAndQty += variant.title + " : " + qty + breakTag;
            bundleString += variant.title + ":" + qty + "|";
          }
        }
      }
    if (bundleStringArray[bundleProdId]) {
      bundleStringArray[bundleProdId] += bundleString;
    } else {
      bundleStringArray[bundleProdId] = bundleString;
    }
    }
    sessionStorage.setItem("bundleStringArray", JSON.stringify(bundleStringArray));
  }
    if(variant.length !== Object.entries(variantOptions).length){
      Notify.error("Please select all product options")
      return
    }

    if(customMessage.length !== customMessageOptions.length){
      Notify.error("Please fill out all options")
      return
    }

    if(product.billingCycleType === "ONE_TIME" && product.recurringProductId){
      if(purchaseOption === "recurring" && !frequency && product.subscriptionOptions){
        Notify.error("Please select your desired frequency")
        return
      }
    }

    if(purchaseOption === "single"){
      frequency = null
    }

    quantity = parseInt(this.quantityInput.current.value)
    variant = Cart.getVariant(product, variant)

    let cartProduct = product
    if(purchaseOption === "recurring" && product.recurringProductId){
      cartProduct = {...subscribeAndSaveProduct, hasSubscriptionOptions: !!product.subscriptionOptions}
    }

    this.props.onAddToCartPressed(cartProduct, variant, customMessage, quantity, frequency)

    this.setState({
      purchaseOption: "single",
      variant: Cart.selectDefaultVariant(product),
      customMessage: [],
      quantity: 1,
    })
  }

  _renderPrice(product, variant){
    let{
      variantOptions,
      website
    } = this.state
    const { product_price_label_color, product_price_padding, product_price_width, product_price_color, product_price_alignment, product_compare_at_price_color, product_price_border_color, product_price_border_style, product_price_background_color } = website?.extra?.product_page_settings;
    const parentPriceStyle = {
      "border": `1px solid ${product_price_border_color}`,
      "border-radius": product_price_border_style,
      "background-color": product_price_background_color,
      "width": product_price_width,
      "padding": product_price_padding,
      "justify-content": product_price_alignment,
    }
    const priceStyle = {
      "color": product_price_color,
    }
    const currency = window.CURRENT_CAMPAIGN?.currencySymbol
    let availableOptionsNo = Object.entries(variantOptions).length

    let price = product.cycle1_price
    let compareAtPrice = product.compareAtPrice
    if((availableOptionsNo > 0) && (variant.length === availableOptionsNo)){
      variant = Cart.getVariant(product, variant)
      if(variant && variant.price){
        price = variant.price
        compareAtPrice = variant.compareAtPrice
      }
    }

    if(product.on_sale){
      return (
        <div style={parentPriceStyle} className='d-flex'>
          <span style={{color: product_compare_at_price_color}} className="h4 type--strikethrough m-0 pr-1">{ Currency.toFormat(price) }</span>
          <span style={priceStyle} className="h4 m-0 pr-2">{ Currency.toFormat(price) }</span>
        </div>
      )
    }

    return (
      <div style={parentPriceStyle} className='d-flex'>
        <span style={{ color: product_price_label_color}} className="h4 m-0 pr-2">Price:</span>
        {compareAtPrice > 0 && <span style={{color: product_compare_at_price_color}} className="h4 type--strikethrough m-0 pr-1">{ Currency.toFormat(compareAtPrice) }</span>}
        <span style={priceStyle} className="h4 m-0">{ Currency.toFormat(price) }</span>
      </div>
    )
  }

  handleVariantQuantityChange = (idx, value) => {
    const { product } = this.state;
    const threshold = product.bundleProductQty || product.productQty;
    let variantQuantities = [...this.state.variantQuantities];
    value = Math.max(0, parseInt(value) || 0);
    variantQuantities[idx] = value;
    const total = variantQuantities.reduce((t, q) => t + q, 0);
  
    if (total > threshold) {
      Notify.error(`Total variant quantity must be ${threshold} for ${product.productName}`);
      return;
    }
    this.setState({ variantQuantities });
  };

  onIncrease = idx => {
    this.handleVariantQuantityChange(idx, this.state.variantQuantities[idx] + 1);
  };
  onDecrease = idx => {
    this.handleVariantQuantityChange(idx, this.state.variantQuantities[idx] - 1);
  };

  _renderBundleVariant() {
    const { product } = this.state;
    if (!product || !product.isVariantBundle || !product.variants?.length) return null;
    return (
      <section className="bundle-variant-section fk-bundle-block">
        <div className="variant-list d-flex flex-column gap-3">
          {product.variants.map((variant, idx) => (
            <div className="variant-block d-flex align-items-center" key={variant.id || idx}>
              <span className="variant-title flex-grow-1">{variant.title}</span>
              <div className="input-number">
                <input
                  type="number"
                  name="quantity"
                  value={this.state.variantQuantities[idx]}
                  min="0"
                  onChange={e => this.handleVariantQuantityChange(idx, e.target.value)}
                />
                <div className="input-number__controls">
                  <span className="input-number__increase" onClick={() => {this.onIncrease(idx)}}>
                    <i className="stack-up-open"></i>
                  </span>
                  <span className="input-number__decrease"
                        onClick={() => {this.onDecrease(idx)}}>
                    <i className="stack-down-open"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
  
        </div>
      </section>
    );
  }

  getVariantIdFromParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId) {
      this.selectVariantFromParam(variantId);
    }
  }

  selectVariantFromParam = (variantId) => {
    const { product } = this.state;
    const matchedVariant = product?.allVariants?.find(v => String(v.id) === String(variantId));

    if (!matchedVariant) return;

    const orderedVariantOptions = Object.entries(this.state.variantOptions).map(([key]) => {
      return matchedVariant.variantOptions[key];
    });

    this.setState({ variant: orderedVariantOptions });
  };

  
  _renderProductVariants(){
    if (!this._isComponentVisible("variants")) {
      return null;
    }
    let {
      product,
      variantOptions,
      variant,
      extra
    } = this.state
    const entries = Object.entries(variantOptions)
    const entriesLength = entries.length
    const selectedTileStyle = extra?.display_variant_tile_price && ["btn_horizontal", "btn_vertical"].includes(extra?.[`variant${entriesLength}_style`] || 'btn_horizontal');
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()
    const imagePosition = extra?.img_tile_position || "right"
    const imageOnlyPosition = imagePosition === "img-only"
    const imageOnlyAspectRatio = extra?.img_only_aspect_ratio || ""
    const leftOrRightPosition = ["left", "right"].includes(imagePosition)

    return <>
    <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Product Variants">
      {this._renderEditButton(productSettingsIds.variants)}
      { product.isVariantBundle ? this._renderBundleVariant() :
        entries.map((key, index) => {
          const words = key[0].toLowerCase().split(" ");
          const isColor = words.includes("color") || words.includes("colour");
          const showVariantPriceOnTile = selectedTileStyle && !isColor && ((index + 1) === entriesLength)
          const variantPriceInfo = showVariantPriceOnTile ? Cart.getLastVariantPriceInfo(product, variant, index + 1) : {}
          const variantImageTile = !isColor && (extra?.[`variant${index + 1}_style`] || "btn_horizontal") === "img_tile"
          const variantImages = variantImageTile && Cart.getProductImagesByVariantNameNumber(product, index + 1, variant)
          const variantImageObj = {
            variantImages,
            leftOrRightPosition,
            imagePosition,
            variantImageTile,
            imageOnlyAspectRatio,
            imageOnlyPosition
          }
          return this._renderVariant(key, index, isColor, variantImageObj, showVariantPriceOnTile, variantPriceInfo)
        })
      }
    </div>
    </>
  }

  _renderVariantTilePrices(variantPriceDetails, oneValidCompareAtPrices){
    let { extra } = this.state
    const currency = window.CURRENT_CAMPAIGN?.currencySymbol || ""
    const campareAtPrice = Number(variantPriceDetails.compareAtPrice || 0)
    const price = Number(variantPriceDetails.price || 0)
    const validCompareAtPrice = campareAtPrice && campareAtPrice > price
    const savings = validCompareAtPrice ? (((campareAtPrice - price)/campareAtPrice) * 100).toFixed(0) + "%" : null
    return (
      <div className={`variant-tile-price-block ${oneValidCompareAtPrices ? '' : 'variant-tile-price-block-height-auto'}`}>
        <div className='variant-tile-price-container'>
          {validCompareAtPrice > 0 ? <div className='variant-tile-compare-price type--strikethrough' style={{ color: extra?.variant_compare_at_price_color}}>{ Currency.toFormat(campareAtPrice) }</div> : null}
          <div className='variant-tile-price' style={{ color: extra?.variant_price_color}}>{ Currency.toFormat(price) }</div>
        </div>
        {savings && <div className='variant-tile-savings'>
          <span>Save {savings}</span>
        </div>}
      </div>
    )
  }

  _renderVariant(key, index, isColor, variantImageObj, showVariantPriceOnTile, variantPriceInfo){
    let {
      extra,
      variant,
      variantOptions
    } = this.state

    if(isColor && !variantOptions.Color){
      return
    }
    const variantParentStyle = {
      background: extra?.variant_bg_color,
      border: `1px solid ${extra?.variant_border_color}`,
      borderRadius: extra?.variant_border_style,
      padding: extra?.variant_padding
    }
    const getVariantBodyStyle = (isSelected = false) => {
      return ({
        background: isSelected ? extra?.selected_tile_color : extra?.variant_tile_color,
        color: extra?.variant_tile_text_color,
        borderRadius: extra?.variant_border_style
      })
    }
    const getLabelStyle = (isSelected = false, isColor = false) => {
      return({ 
        borderColor: isSelected? extra?.selected_tile_border_color : extra?.variant_tile_border_color,
        backgroundColor: isColor ? isSelected ? extra?.selected_tile_color : extra?.variant_tile_color : "none",
        color: isColor ? extra?.variant_tile_text_color : "none",
        borderRadius: !isColor ? extra?.variant_border_style :  "none"
      })
    }
    let colorStyle = extra?.color_picker_style || "square"

    let variantKey = `variant${index+1}_style`
    let variantStyle = extra[variantKey] || "btn_horizontal"

    const title = key[0];
    const options = key[1];
    const selectType = isColor ? colorStyle : variantStyle;
    const {
      variantImages,
      leftOrRightPosition,
      imagePosition,
      variantImageTile,
      imageOnlyAspectRatio,
      imageOnlyPosition
    } = variantImageObj
    return (
      <div
        className={`${isColor ? 'color-swatches' : 'sizes'} my-28px`}
        style={variantParentStyle}
      >
        <h4 className="mb-2" style={{color: extra?.variant_label_text_color}}>{title}</h4>
        {
          selectType === 'dropdown' ?
            <div className="input-select">
              <select
                value={variant[index]}
                onChange={this.handleVariantChange(index, isColor, key)}
              >
                <option>Select {title}</option>
                {options.map((option, optionIndex) => {
                  return (
                    <option key={optionIndex} value={option}>
                      {option}
                    </option>
                  )
                })}
              </select>
            </div>
          :
            <div className={`items ${selectType}`}>
              {options.map((option, optionIndex) => {
                return (
                  <div
                    key={optionIndex}
                    className={`item input-radio input-radio--innerlabel ${variantImageTile ? `product-variant-tile-label-container product-variant-tile-label-container-${imagePosition}` : ""}`}
                    title={option}
                    style={ !isColor ? getVariantBodyStyle(variant[index] === option) : undefined}
                  >
                    <input
                      type="radio"
                      name={key[0]}
                      value={option}
                      id={`${key[0]}-${optionIndex}`}
                      checked={variant[index] === option}
                      onChange={this.handleVariantChange(index, isColor, key)}
                    />
                    {
                      variantImageTile ?
                        <label style={getLabelStyle( variant[index] === option)} htmlFor={`${key[0]}-${optionIndex}`} className={`btn ${variantImageTile ? `product-variant-tile-label product-variant-tile-label-${imagePosition} ${!imageOnlyPosition && !variantImages[option] ? "product-variant-tile-has-no-img" : ""}` : ""}`}>
                          <div className={`product-variant-tile-block product-variant-tile-img-position-${imagePosition}`}>
                            {!imageOnlyPosition && <div className='product-variant-tile-text-container'>
                              {leftOrRightPosition && option?.length > 18 ? option.substring(0, 18) + "..." : option}
                            </div>}
                            <div className={`product-variant-tile-image-container ${imageOnlyPosition && imageOnlyAspectRatio ? `${imageOnlyAspectRatio} product-variant-tile-image-width` : ""}`}>
                              {
                                (imageOnlyPosition ? variantImages[option] : true) && <img className={`product-variant-tile-image ${imageOnlyPosition && imageOnlyAspectRatio ? "product-variant-tile-image-aspect-ratio" : ""}`} src={variantImages[option]} alt={option} />}
                              {
                                imageOnlyPosition && !variantImages[option] && (<div className='product-variant-tile-no-image-text-container'>{ option?.length > 18 ? option.substring(0, 18) + "..." : option }</div>)
                              }
                            </div>
                          </div>
                        </label>
                      :
                      <>
                        <label  style={getLabelStyle( variant[index] === option, isColor)} htmlFor={`${key[0]}-${optionIndex}`} className={isColor ? '' : `btn ${showVariantPriceOnTile ? 'variant-tile-price-label' : ''}`}>
                          {isColor ? <span className='color' style={{ backgroundColor: option }}></span> : option}
                          {isColor ? <span className='name'>{option}</span> : null}
                          {showVariantPriceOnTile && this._renderVariantTilePrices(variantPriceInfo?.pricesObj?.[option], variantPriceInfo?.oneValidCompareAtPrices)}
                        </label>
                      </>
                    }
                  </div>
                )
              })}
            </div>
        }
      </div>
    )
  }

  _renderCustomMessage(){
    if (!this._isComponentVisible("customMessageOptions")) {
      return null;
    }
    const { customMessage, customMessageOptions } = this.state;
    if (customMessageOptions.length < 1) return null;

    const cmStyles = this.generateCustomMessageStyles();
    const textColor = cmStyles?.color;
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()
    const customMessageOptionsInputs = customMessageOptions.map((customMessageOption, index) => {
      return (
        <div
          className="my-28px"
          style={cmStyles}
          key={index}
        >
          <h4 className="mb-2" style={textColor ? { color: textColor } : {}}>
            {customMessageOption}
          </h4>

          <div>
            <input
              type="text"
              placeholder={customMessageOption}
              value={customMessage[index]?.split(":")[1] || ""}
              onChange={e => {
                const arr = [...customMessage];
                arr[index] = `${customMessageOption}:${e.target.value}`;
                this.setState({ customMessage: arr });
              }}
            />
          </div>
        </div>
      );
    });

    return (
      <div>
        <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Custom Message Options">
          {this._renderEditButton(productSettingsIds.customMessageOptions)}
          {customMessageOptionsInputs}
        </div>
      </div>
    );
  }


  handleVariantChange(index, isColor, key) {
    return (e) => {
      const selectedOptionName = e.target.value;
      const variant = [...this.state.variant];

      if (selectedOptionName === key[0]) {
        variant[index] = null;
      } else {
        variant[index] = selectedOptionName;
      }

      this.setState({ variant }, () => {
        setTimeout(() => {
          General.updateSlides();
          General.updateLazyBackgroundImages();
        }, 50);
      });
    };
  }

_renderSubScribeSave(){
  if (!this._isComponentVisible("subAndSave")) {
      return null;
    }
  let {
    product,
    variant,
    variantOptions,
    subscribeAndSaveProduct,
    subscribeAndSaveVariantOptions,
    subscribeAndSaveSettings
  } = this.state
  let subscribeAndSaveVariant = General.clone(variant)

  const hasSubscriptionOptions = !!product.subscriptionOptions;
  const hasValidSubscribeAndSave = !!(subscribeAndSaveProduct && subscribeAndSaveProduct.cycle1_billDelay);

  if (!hasSubscriptionOptions && !hasValidSubscribeAndSave) return null;

  //Price & Frequency calculations
  const {
    price,
    subscribeAndSavePrice,
    subscribeAndSaveFrequency,
    readOnly,
    discountText
  } = this._calculatePricing(
    product,
    variant,
    variantOptions,
    subscribeAndSaveProduct,
    subscribeAndSaveVariantOptions,
    subscribeAndSaveSettings
  );

  const layoutStyle = subscribeAndSaveSettings.layoutStyle;
  const isTabLayout = layoutStyle === "tab";
  const isCheckboxLayout = layoutStyle === "checkbox";
  const isHorizontalLayout = layoutStyle === "horizontal";
  const containerMode = isTabLayout ? "tab" : isCheckboxLayout ? "checkbox" : isHorizontalLayout ? "horizontal" : "list";

  const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()

  return (
    <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Subscribe & Save">
      {this._renderEditButton(productSettingsIds.subAndSave)}
      <div
        className={`subscribe-save my-28px ${isTabLayout ? "tab-layout" : isCheckboxLayout ? "checkbox-layout" : isHorizontalLayout ? "horizontal-layout" : "list-layout"}`}
        style={{
          "--border-color": subscribeAndSaveSettings.borderColor,
          "--selected-border-color": subscribeAndSaveSettings.selectedBorderColor,
          "--background-color": subscribeAndSaveSettings.backgroundColor,
          "--selected-background-color": subscribeAndSaveSettings.selectedBackgroundColor,
          "--text-color": subscribeAndSaveSettings.textColor,
          "--selected-text-color": subscribeAndSaveSettings.selectedTextColor,
          "--border-radius": subscribeAndSaveSettings.borderStyle
        }}
      >
        {/* One Time + Recurring */}
        <div className={`radio-container ${containerMode}`}>
          {!isCheckboxLayout ? (
            <>
              {this._renderOneTimeOption(price, layoutStyle)}
              {this._renderRecurringOption(subscribeAndSavePrice, subscribeAndSaveFrequency, readOnly, discountText, layoutStyle)}
            </>
          ) : (this._renderCheckboxRecurringOption(subscribeAndSavePrice, subscribeAndSaveFrequency, readOnly, discountText))}
        </div>
        {isTabLayout && this._renderTab(price, subscribeAndSavePrice, subscribeAndSaveFrequency, readOnly, discountText)}
      </div>
    </div>
  );
}

/*One Time Purchase*/
_renderOneTimeOption(price, layoutStyle) {
  const { purchaseOption } = this.state;
  const isSelected = purchaseOption === "single";
  const isTabLayout = layoutStyle === 'tab';

  return (
    <div className={`option ${isSelected ? "selected" : ""} single`}>
      <input
        id="subscribe-single"
        type="radio"
        name="subscribe"
        value="single"
        checked={isSelected}
        onChange={() => this.setState({ purchaseOption: "single" })}
        hidden
      />
      <label htmlFor="subscribe-single" className="w-100" style={{ cursor: "pointer" }}>
        <div className="t-sec">
          {this._renderIcon("single", isSelected)}
          <div className="name">One Time Purchase</div>
          {!isTabLayout ? <div className="price">{Currency.toFormat(price)}</div> : null}
        </div>
        {isSelected && !isTabLayout && this._renderSubAndSaveMetaField("onetime")}
      </label>
    </div>
  );
}

/*Recurring*/
_renderRecurringOption(price, frequency, readOnly, discountText, layoutType) {
  const { product, subscribeAndSaveProduct, purchaseOption } = this.state;
  const isSelected = purchaseOption === "recurring";
  const isTabLayout = layoutType === "tab";

  return (
    <div className={`option ${isSelected ? "selected" : ""} recurring`}>
      <input
        id="subscribe-recurring"
        type="radio"
        name="subscribe"
        value="recurring"
        checked={isSelected}
        onChange={() => {
          let update = { purchaseOption: "recurring" };
          if (!product.subscriptionOptions && subscribeAndSaveProduct?.cycle1_billDelay) {
            update.frequency = `${subscribeAndSaveProduct.cycle1_billDelay} Days`;
          }
          this.setState(update);
        }}
        hidden
      />
      <label htmlFor="subscribe-recurring" className="w-100" style={{ cursor: "pointer" }}>
        <div className="t-sec">
          {this._renderIcon("recurring", isSelected)}
          <div className="name">Subscribe and Save</div>
          {layoutType !== "tab" && discountText ? (
            <div className="discount">{discountText}</div>
          ) : null}
          {!isTabLayout ? <div className="price">{Currency.toFormat(price)}</div> : null}
        </div>

        {isSelected && !isTabLayout ? (
          <div className="b-sec">
            <div className="frequency">
              <div className="input-select">
                <select disabled={readOnly} onChange={e => this.setState({ frequency: e.target.value })}>
                  {frequency?.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>
              {this._renderSubAndSaveMetaField("recurring")}
          </div>
        ) : null}
      </label>
    </div>
  );
}

_renderCheckboxRecurringOption(price, frequency, readOnly, discountText) { 
  const { product, subscribeAndSaveProduct, purchaseOption } = this.state;
  const isSelected = purchaseOption === "recurring"; 
 
  return (
    <div className={`option ${isSelected ? "selected" : ""} recurring`}>  
      <div className="d-flex justify-content-between">
        <div className="d-flex" style={{gap: "8px"}}>
          <div className="input-checkbox mt-0">
            <input
              id={"subscribe-checkbox"}
              type="checkbox"
              checked={isSelected}
              onChange={() => {
                const update = {};
                if (isSelected) {
                  update.purchaseOption = "single";
                } else {
                  update.purchaseOption = "recurring";
                  if (!product.subscriptionOptions && subscribeAndSaveProduct?.cycle1_billDelay) {
                    update.frequency = `${subscribeAndSaveProduct.cycle1_billDelay} Days`;
                  }
                }
                this.setState(update);
              }}
            />
            <label htmlFor={"subscribe-checkbox"} className="ss-checkbox"></label>
          </div>
          <div className="t-sec"> 
            <div className="name">Subscribe & Save </div> 
            {discountText && <div className="discount">{discountText}</div>} 
          </div>
        </div>
          <div className="price">{Currency.toFormat(price)}</div> 
      </div>
      <div className="b-sec"> 
        <div className="frequency"> 
          <div className="name">Frequency:</div> 
          <div className="input-select"> 
            <select 
              disabled={readOnly} 
              onChange={(e) => this.setState({ frequency: e.target.value })} 
            > 
              {frequency?.map((option) => ( 
                <option key={option.value} value={option.value}> 
                  {option.label} 
                </option> 
              ))} 
            </select> 
          </div> 
        </div> 
        {this._renderSubAndSaveMetaField("recurring")} 
      </div> 
    </div>
  ); 
}

_renderTab(price, recurringPrice, frequency, readOnly, discountText) {
  const { purchaseOption } = this.state;
  return (
    <div className="radio-tab-content">
      {purchaseOption === "recurring" ? (
        <>
          <div className="sub-style">
            {discountText && <div className="discount">{discountText}</div>}
            <div className="price">{Currency.toFormat(recurringPrice)}</div>
          </div>
          <div className="b-sec">
            <select
              disabled={readOnly}
              onChange={e => this.setState({ frequency: e.target.value })}
            >
              {frequency?.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          {this._renderSubAndSaveMetaField("recurring")}
        </>
      ) : (
        <div className="one-style">
          <div className="price">{Currency.toFormat(price)}</div>
          {this._renderSubAndSaveMetaField("onetime")}
        </div>
      )}
    </div>
  );
}
/*Icon Renderer*/
_renderIcon(value, isSelected) {
  const { subscribeAndSaveSettings } = this.state;
  const iconClass = value === 'recurring' ? subscribeAndSaveSettings.subscribeIcon : subscribeAndSaveSettings.oneTimeIcon;
  const iconColor = isSelected ? "var(--selected-text-color)" : "var(--text-color)";
  if (getIconType(iconClass) === 'svg') {
    return <img className="m-0" height={18} src={getSVGIcon(iconClass)} />;
  }
  return (
    <div className={`dot ${subscribeAndSaveSettings.useCustomIcon ? 'icon-mode' : ''}`} style={{ display: "flex", alignItems: "center" }}>
      {iconClass ? (
        <i className={getStandardIcon(iconClass)} style={{ fontSize: 16, color: iconColor }} />
      ) : <span />}
    </div>
  );
}

/*Pricing/Frequency*/
_calculatePricing(product, variant, variantOptions, subscribeAndSaveProduct, subscribeAndSaveVariantOptions, settings) {
  //One-time price
  let availableOptionsNo = Object.entries(variantOptions).length;
  let price = product.cycle1_price;
  if ((availableOptionsNo > 0) && (variant.length === availableOptionsNo)) {
    let matching = Cart.getVariant(product, variant);
    if (matching?.price) price = matching.price;
  }

  //Frequency
  let subscribeAndSaveFrequency = null, readOnly = false;
  if (product.subscriptionOptions) {
    subscribeAndSaveFrequency = product.subscriptionOptions.split(",").map(option => ({ value: option, label: option }));
    subscribeAndSaveFrequency.unshift({ value: null, label: "Select Frequency" });
  } else if (subscribeAndSaveProduct.cycle1_billDelay) {
    readOnly = true;
    subscribeAndSaveFrequency = [{ value: subscribeAndSaveProduct.cycle1_billDelay, label: `${subscribeAndSaveProduct.cycle1_billDelay} Days` }];
  }

  //Subscribe & Save price
  let subscribeAndSavePrice = subscribeAndSaveProduct.cycle1_price;
  let subsOptionsNo = Object.entries(subscribeAndSaveVariantOptions).length;
  let subscribeVariant = [...variant];
  if ((subsOptionsNo > 0) && (subscribeVariant.length === subsOptionsNo)) {
    let matching = Cart.getVariant(subscribeAndSaveProduct, subscribeVariant);
    if (matching?.price) subscribeAndSavePrice = matching.price;
  }

  //Discount
  let discountText = "";
  const oneTimePrice = parseFloat(price);
  const recurringPrice = parseFloat(subscribeAndSavePrice);
  if (!isNaN(oneTimePrice) && !isNaN(recurringPrice) && recurringPrice < oneTimePrice) {
    const priceDiff = oneTimePrice - recurringPrice;
    const percent = Math.round((priceDiff / oneTimePrice) * 100);
    switch (settings.discountFormat) {
      case 'price': discountText = <>save {Currency.toFormat(priceDiff)}</>; break;
      case 'percent': discountText = `save ${percent}%`; break;
      case 'both': discountText = <>save {Currency.toFormat(priceDiff)} ({percent}%)</>; break;
    }
  }

  return { price, subscribeAndSavePrice, subscribeAndSaveFrequency, readOnly, discountText };
}  

  _renderMainSlider(autoplay) {
    const { imageShape, imageNavShape, imageSliderPosition } = this.state;
    return (
      <div
        key={`main-${imageSliderPosition}-${imageShape}-${imageNavShape}`}
        className={`slider-product-main slider border--round boxed--border img-shape-${imageShape || 'rounded'} nav-shape-${imageNavShape || 'square'}`}
        data-paging="true"
        data-arrows="true"
        data-autoplay={autoplay}
      >
        {this._renderSlides()}
      </div>
    );
  }

  _renderNavSlider(isVertical) {
    const { carouselShape, imageNavShape, imageSliderPosition } = this.state;
    return (
      <div
        key={`nav-${imageSliderPosition}-${carouselShape}-${imageNavShape}`}
        className={`${isVertical ? 'vertical-product-nav position-absolute' : 'slider-product-nav'} slider border--round boxed--border carousel-shape-${carouselShape || 'rounded'} nav-shape-${imageNavShape || 'square'}`}
        data-asNavFor=".slider-product-main .slides"
        data-asNavTrue="true"
      >
        {this._renderSlides()}
      </div>
    );
  }

  _renderSlides(){
    let {
      key,
      variant,
      product,
      imageShape,
    } = this.state

    if(product == null){
       return null
    }

    let images = [{original: product.imageUrl}]

    if(product.imageUrls){
      images = product.imageUrls.map(imageUrl => {
        return {original: imageUrl}
      })
    }

    let selectedVariant = Cart.getVariant(product, variant)
    if(selectedVariant?.imageUrl){
      images.unshift({original: selectedVariant.imageUrl})
    }

    return (
      <ul key={`${images.length}-${imageShape}`} className={`slides ${imageShape === "square" ? imageShape : ''}`}>
        {
          images.map((image, index) => {
            return (
              <li
                className="lazy-background"
                key={index}
                style={{ backgroundImage: "url(" + getImageUrl(image, "product-page") + ")" }}
                priority={this.props.index}
              ></li>
            )
          })
        }
      </ul>
    )
  }

  _renderTabTitles(infos, extra){
    return infos.map((info, index) => {
      let className = index === 0 ? "active" : ""
      let id = "textInfo_"+index
      const borderStyle = index !== infos.length - 1 ? { borderRight: `1px solid ${extra?.meta_field_border_color}` } : {};
      return (
        <li key={id} className={className} style={borderStyle}>
          <div className="tab__title">
              <span style={{ color: extra?.meta_field_text_color}}>{ info.name }</span>
          </div>
        </li>
      )
    })
  }

  _renderTabContent(infos, extra){
    return infos.map((info, index) => {
      let className = index === 0 ? "active" : ""
      let id = "textInfo_"+index
      return (
        <li key={ id } id={ id } className={className}>
          <div className="tab__content" style={{ color: info.valueType !== "RICH_TEXT" && extra?.meta_field_body_text_color}}>
              {
                info.valueType === "RICH_TEXT" ? <ShadowRoot><div dangerouslySetInnerHTML={{ __html: info.value }} ></div></ShadowRoot> : <p className="pre">{ info.value }</p>
              }
          </div>
        </li>
      )
    })
  }

  _renderCollapsibleList(){
    const { product, extra } = this.state
    const metaFields = Cart.getProductMetaData(product)
    if(!metaFields.length){
      return
    }
    const openIcon = extra?.collapsible_list_open_icon
    const closeIcon = extra?.collapsible_list_close_icon
    const autoToggle = extra?.collapsible_list_toggle
    return <>
      <section className='p-0'>
        <div className="container">
          <div className="row justify-content-center">
              <div className="col-md-12 p-0">
                <CollapsibleList extra={extra} data={metaFields} openIcon={openIcon} closeIcon={closeIcon} autoToggle={typeof autoToggle === "boolean" ? autoToggle : true} />
              </div>
          </div>
        </div>
      </section>
    </>
  }

  _renderTabs(){
    let {
      product,
      website,
      editable,
      extra
    } = this.state

    const metaFields = Cart.getProductMetaData(product)

    if(!metaFields.length){
      return
    }

    return (
      <>
        {/* starts, Product Tabs */}
        <section className='p-0'>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 p-0">
                <div id="product-tabs" className="tabs-container tabs--folder">
                  <>
                    <ul className="tabs" style={{backgroundColor: extra?.meta_field_bg_color, borderColor: extra?.meta_field_border_color, borderRadius: extra?.meta_field_border_style === "0px" && extra?.meta_field_border_style}}>
                      { this._renderTabTitles(metaFields, extra)}
                    </ul>
                    <ul className="tabs-content" style={{backgroundColor: extra?.meta_field_body_bg_color, borderColor: extra?.meta_field_border_color, borderRadius: extra?.meta_field_border_style === "0px" && extra?.meta_field_border_style}}>
                      { this._renderTabContent(metaFields, extra)}
                    </ul>
                  </>
                </div>
                { General.renderTabStyle({
                    secondary_color: extra?.meta_field_selected_tab_color ?? website.primary_color,
                  }, "product-tabs")
                }
              </div>
            </div>
          </div>
        </section>
        {editable && window.$ && window?.mr?.tabs?.documentReady(window.$)}
        {/* } end, Product Tabs  */}
      </>
    )
  }

  _renderQuantityAndButtons() {
    if (!this._isComponentVisible("quantityAndButtonsOptions")) {
      return null;
    }
    const {quantity, product} = this.state;
    const checkoutType = window.CURRENT_WEBSITE.checkout_type;
    const isBoth = checkoutType === "instantAndCart" || checkoutType === "instantAndBuy";
    const cartButtonText = checkoutType === "instant" ? "Buy Now" : "Add To Cart";
    const qbStyles = this.generateQuantityButtonsStyles();
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()

    return (
      <>
        <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Quantity and Buttons">
          {this._renderEditButton(productSettingsIds.quantityAndButtonsOptions)}
          <div className='row quan-cart my-38px mx-0' style={qbStyles}>
            <div className='col-lg-3 col-md-12 pl-0'>
              <div className="input-number">
                <input
                  ref={this.quantityInput}
                  type="number"
                  name="quantity"
                  value={quantity}
                  min="1"
                  onChange={e => this.setState({quantity: parseInt(e.target.value)})}
                />
                <div className="input-number__controls">
                  <span className="input-number__increase" onClick={() => {if (product?.isVariantBundle) return; this.setState({quantity: quantity + 1})}}>
                    <i className="stack-up-open"></i>
                  </span>
                  <span className="input-number__decrease"
                        onClick={() => {if (product?.isVariantBundle) return; this.setState({quantity: Math.max(1, quantity - 1)})}}>
                    <i className="stack-down-open"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className='col-lg-9 col-md-12 px-0'>
              <div className="sticky-buttons-wrapper d-flex flex-row w-100 justify-content-between">
                {isBoth ? (
                  <>
                    <a className="btn btn--primary sticky-btn flex-fill px-4 col-md-12" style={qbStyles.addToCartBtnColor ? { backgroundColor: qbStyles.addToCartBtnColor } : {}} onClick={() => {
                      window.CURRENT_WEBSITE.checkout_type = "instantAndCart";
                      this._handleAddToCart();
                    }}>
                      <span className="btn__text" style={qbStyles.addToCartTextColor ? { color: qbStyles.addToCartTextColor } : {}}>Add To Cart</span>
                    </a>
                    <a className="btn btn--secondary sticky-btn flex-fill px-4 col-md-12" style={qbStyles.buyNowBtnColor ? { backgroundColor: qbStyles.buyNowBtnColor } : {}} onClick={() => {
                      window.CURRENT_WEBSITE.checkout_type = "instantAndBuy";
                      this._handleAddToCart();
                    }}>
                      <span className="btn__text"  style={qbStyles.buyNowTextColor ? { color: qbStyles.buyNowTextColor } : {}}>Buy Now</span>
                    </a>
                  </>
                ) : (
                  <a
                    className="btn btn--primary w-100"
                    style={
                      cartButtonText === "Buy Now"
                        ? { backgroundColor: qbStyles.buyNowBtnColor }
                        : { backgroundColor: qbStyles.addToCartBtnColor }
                    }
                    onClick={() => this._handleAddToCart()}
                  >
                    <span
                      className="btn__text"
                      style={
                        cartButtonText === "Buy Now"
                        ? { color: qbStyles.buyNowTextColor }
                        : { color: qbStyles.addToCartTextColor }
                      }
                    >
                      {cartButtonText}
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  _renderProductMedia() {
    if (!this._isComponentVisible("productImage")) {
      return null;
    }
    const { extra, product, imageSliderPosition, imageBorderColor, imageSelectedBorderColor, imageNavButtonColor } = this.state;
    const isVertical = imageSliderPosition === 'left';
    const autoplay = extra?.autoplay_carousel_toggle ? "true" : "false";
    const styleVars = {
      '--pd-image-border-color': imageBorderColor || '',
      '--pd-image-selected-border-color': imageSelectedBorderColor || '',
      '--pd-image-nav-button-color': imageNavButtonColor || '',
    };
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()

    if (isVertical) {
      const showVerticalSlider = product.imageUrls?.length > 1;
      return (
        <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Product Image & Carousel">
          {this._renderEditButton(productSettingsIds.productImage)}
          <div className="carousel-parent row position-relative" style={styleVars}>
            {showVerticalSlider && (
              <div className="vertical-wrapper col-2 position-relative">
                {this._renderNavSlider(isVertical)}
              </div>
            )}
            <div className={showVerticalSlider ? 'col-lg-10 col-md-10 col-sm-12' : 'col-12'}>
              {this._renderMainSlider(autoplay)}
              <BadgeBlock product={product} />
            </div>
          </div>
        </div>
      );
    }
    return (
      <>
        <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Product Image & Carousel">
          {this._renderEditButton(productSettingsIds.productImage)}
          <div>
            <div className="position-relative" style={styleVars}>
              {this._renderMainSlider(autoplay)}
              <BadgeBlock product={product} />
            </div>
            {this._renderNavSlider(isVertical)}
          </div>
        </div>
      </>
    );
  }



  _renderProductDescription() {
    if (!this._isComponentVisible("productDescription")) {
      return null;
    }
    const { product, extra} = this.state
    if (!product.productDescription) {
      return null
    }
    const {
      product_description_background_color,
      product_description_shape,
      product_description_border_color,
      product_description_header_text,
      product_description_header_text_color,
      product_description_body_text_color
    } = extra || {}
    const containerStyles = {}
    if (product_description_background_color) {
      containerStyles.backgroundColor = product_description_background_color
    }
    if (product_description_shape === "rounded") {
      containerStyles.borderRadius = "10px"
    }
    if (product_description_border_color) {
      containerStyles.border = `2px solid ${product_description_border_color}`
    }
    const headerTextColorStyles = {}
    if (product_description_header_text_color) {
      headerTextColorStyles.color = product_description_header_text_color
    }
    const bodyTextColorStyles = {}
    if (product_description_body_text_color) {
      bodyTextColorStyles.color = product_description_body_text_color
    }
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()
    return (
      <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Product Description">
        {this._renderEditButton(productSettingsIds.productDescription)}
        <section className="switchable p-2" style={containerStyles}>
          <div className="container">
            <div className="row">
              <div className="col-md-12 p-0">
                <h2 style={headerTextColorStyles}>{product_description_header_text?.trim() || "Product Description"}</h2>
                <div className="lead pre" style={bodyTextColorStyles} dangerouslySetInnerHTML={{__html: product.productDescription}}/>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  _renderMetaFields() {
    if (!this._isComponentVisible("metafields")) {
      return null;
    }
    const {extra} = this.state;
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass()
    return (
      <div className={`storefront-custom-edit-block mt-5 ${quickSettingsHighlightClass}`} data-label="Metafields">
        {this._renderEditButton(productSettingsIds.metaFields)}
        {
          extra?.meta_field_type === "collapsible-list"
            ? this._renderCollapsibleList()
            : this._renderTabs()
        }
      </div>
    )
  }

  _generateShareStyles() {
    const settings = this.state?.website?.extra?.product_page_settings || {};
    const {
      share_border_style = '0px',
      share_border_color,
      share_background_color,
      share_alignment = 'center',
      share_width = '100%',
      share_padding = '0',
      share_text_color,
    } = settings;

    const justifyMap = { left: 'flex-start', center: 'center', right: 'flex-end' };

    const container = {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      justifyContent: justifyMap[share_alignment] || 'center',
      width: share_width,
      padding: share_padding,
      borderRadius: share_border_style,
      backgroundColor: share_background_color || 'transparent',
    };

    if (share_border_color) {
      container.border = `1px solid ${share_border_color}`;
    }

    const text = {};
    if (share_text_color) {
      text.color = share_text_color;
    }

    return { container, text, color: share_text_color };
  }

  _renderShareIcon(iconClass, color) {
    if (!iconClass || iconClass === "standard|undefined|") {
      // Fallback (your previous pill icon look)
      return <span className="r-box material-icons bg-c-primary">share</span>;
    }

    if (getIconType(iconClass) === 'svg') {
      return <img className="m-0" height={18} src={getSVGIcon(iconClass)} alt="share" />;
    }

    return <i className={getStandardIcon(iconClass)} style={{ fontSize: 18, color }} />;
  }

  _renderShareSection() {
    if (!this._isComponentVisible("shareProduct")) {
      return null;
    }
    const { showShareModal, website } = this.state;
    const settings = website?.extra?.product_page_settings || {};
    const { share_icon } = settings;

    const { container, text, color } = this._generateShareStyles();
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass();

    return (
      <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Share Product">
        {this._renderEditButton(productSettingsIds.shareProduct)}
        <div className="link-share" style={container}>
          {this._renderShareIcon(share_icon, color)}
          <a
            href="javascript:void(0)"
            className="text-uppercase type--underline link--primary"
            style={text}
            onClick={() => this.setState({ showShareModal: true })}
          >
            Share this Product
          </a>
        </div>

        <ShareModal
          show={showShareModal}
          title="Share This Product"
          message="Copy the link below to share this product"
          shareTitle="Checkout This Product"
          url={window.location}
          onHide={() => this.setState({ showShareModal: false })}
          onAdded={() => this.setState({ showShareModal: false })}
        />
      </div>
    );
  }

  generateTitleStyles() {
    const { website } = this.state;
    const { product_title_alignment, product_title_background_color, product_title_border_color, product_title_border_style, product_title_color, product_title_width, product_title_padding} = website?.extra?.product_page_settings;
    return {
      "border": `1px solid ${product_title_border_color}`,
      "border-radius": product_title_border_style,
      "background-color": product_title_background_color,
      "text-align": product_title_alignment,
      "color": product_title_color,
      "width": product_title_width,
      "padding": product_title_padding
    }
  }
  generateCustomMessageStyles() {
    const settings = this.state?.website?.extra?.product_page_settings || {};
    const textAlign = settings.custom_message_alignment ?? 'left';
    const backgroundColor = settings.custom_message_background_color ?? 'transparent';
    const color = settings.custom_message_color ?? 'inherit';
    const padding = settings.custom_message_options_padding ?? '0';
    const borderColor = settings.custom_message_border_color || null;
    const borderRadius = settings.custom_message_border_style ?? '0px';
    const width = settings.custom_message_width || null;
    const styles = {
      textAlign,
      backgroundColor,
      color,
      padding,
      borderRadius,
    };
    if (borderColor) {
      styles.border = `1px solid ${borderColor}`;
    }
    if (width) {
      styles.width = width;
    }
    return styles;
  }

  generateQuantityButtonsStyles() {
    const settings = this.state?.website?.extra?.product_page_settings || {};
    const borderRadius = settings.quantity_buttons_border_style ?? '0px';
    const borderColor = settings.quantity_buttons_border_color || null;
    const backgroundColor = settings.quantity_buttons_background_color ?? 'transparent';
    const addToCartBtnColor = settings.quantity_button_addToCart_btn_color ?? '';
    const addToCartTextColor = settings.quantity_button_addToCart_text_color ?? '';
    const buyNowBtnColor = settings.quantity_button_buyNow_btn_color ?? '';
    const buyNowTextColor = settings.quantity_button_buyNow_text_color ?? '';
    const padding = settings.quantity_buttons_padding ?? '0';
    const styles = {
      borderRadius,
      borderColor,
      backgroundColor,
      addToCartBtnColor,
      addToCartTextColor,
      buyNowBtnColor,
      buyNowTextColor,
      padding,
    };
    if (borderColor) {
      styles.border = `1px solid ${borderColor}`;
    }
    return styles;
  }

  _renderProductName() {
    if (!this._isComponentVisible("Title")) {
      return null;
    }
    const {product} = this.state;
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass();
    return (
      <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Product Title">
        {this._renderEditButton(productSettingsIds.productTitle)}
        <h2 style={this.generateTitleStyles()} className='fs-md-30'>{product.productName}</h2>
      </div>
    );
  }

  _renderProductPrice() {
    if (!this._isComponentVisible("Price")) {
      return null;
    }
    const {product, variant} = this.state;
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass();
    return (
      <div className={`text-block d-flex align-items-center mb-0 storefront-custom-edit-block mt-5 ${quickSettingsHighlightClass}`} data-label="Product Price">
        {this._renderEditButton(productSettingsIds.productPrice)}
        {this._renderPrice(product, variant)}
        {product.on_sale && (
          <span className="label position-static product-sale-price">Sale</span>
        )}
      </div>
    );
  }

  _getDeviceFromWidth = () => {
    const width = window?.innerWidth || 992;
    if (width > 992) return 'desktop';
    if (width > 768) return 'tabletlarge';
    if (width > 600) return 'tablet';
    if (width > 480) return 'mobilelarge';
    return 'mobile';
  };

  _getVisibility = (index) => {
    const settings = this.state?.website?.extra?.product_page_settings || {};
    const details = settings?.visibility?.detail;
    const arrIndex = Math.max(0, index - 1);

    const defaultVisibility  = {
      desktop: true,
      tabletlarge: true,
      tablet: true,
      mobilelarge: true,
      mobile: true,
    };

    const per = Array.isArray(details) ? (details[arrIndex] || {}) : {};
    const vis = { ...defaultVisibility , ...per };

    return Object.entries(vis)
      .filter(([, isVisible]) => !!isVisible)
      .map(([device]) => device);
  };
  _isComponentVisible(componentKey) {
    const deviceType = typeof window !== 'undefined' ? this._getDeviceFromWidth() : 'desktop';
    const settings = this.state?.website?.extra?.product_page_settings || {};
    const visibility = settings?.visibility?.[componentKey];
    if (!visibility) {
      return true;
    }
    return visibility[deviceType] !== false;
  }
  _renderDetail(index) {
    const deviceType = typeof window !== 'undefined' ? this._getDeviceFromWidth() : 'desktop';
    const visibility = this._getVisibility(index);
    if (!visibility.includes(deviceType)) {
      return;
    }

    const metaFields = this.state.product?.metaFields || [];

    const field = metaFields.find(f =>
      typeof f.name === "string" &&
      f.name.toLowerCase().replace(/\s+/g, '') === `storefront-detail-${index}`
    );

    if (!field || !field.value || field.value.toLowerCase() === 'show') {
      return null;
    }
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass();
    return (
      <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label={`Product Detail ${index}`}>
        {this._renderEditButton(productSettingsIds.detail, index)}
        <div
          className={`storefront-detail storefront-detail-${index}`}
          key={`meta-${index}`}
          dangerouslySetInnerHTML={{ __html: field.value }}
        />
      </div>
    );
  }

  _renderSubAndSaveMetaField(type) {
    if (!['onetime','recurring'].includes(type.toLowerCase())) {
      return null;
    }
    const metaFields = this.state.product?.metaFields || [];

    const field = metaFields.find(f =>
      typeof f.name === "string" &&
      f.name.toLowerCase().replace(/\s+/g, '') === `storefront-${type}`
    );

    if (!field || !field.value || field.value.toLowerCase() === 'show') {
      return null;
    }

    return (
      <div
        className='sub-and-save-meta-isolated'
        key={`meta-${type}`}
        dangerouslySetInnerHTML={{__html: field.value}}
      />
    );
  }

  render(){
    let {
      product,
      website,
      variant,
      quantity,
      funnelJson,
      indexLoaded,
      campaignJson,
      showShareModal,
      variantOptions,
      loading,
      extra,
      evenColumnWidth,
      layoutOrder
    } = this.state

    if(!product || !variantOptions){
      return null
    }

    return (
      <>
        <div className="row justify-content-around">
          {/* starts, column right, sticky sidebar  */}
          <div className={`col-md-${evenColumnWidth ? 6 : 5}`}>
            <div className="sidebar__inner">
              {this._renderColumnSections("right", layoutOrder)}
            </div>
          </div>
          {/* end, column right, sticky sidebar  */}

          {/* starts, column left  */}
          <div className={`col-md-${evenColumnWidth ? 6 : 7} ${extra?.sticky_left_column ? "sticky-left-column" : ""}`}>
            {this._renderColumnSections("left", layoutOrder)}
          </div>
        </div>
        {/* end, column left  */}
        <div className="row justify-content-around">
          {/* starts, bottom row  */}
          <div className="col-12 mb-4">
            {this._renderColumnSections("row", layoutOrder)}
          </div>
          {/* end, bottom row  */}
        </div>
      </>
    )
  }
}
